// import { shoptourApi } from 'yxt-biz-pc/packages/api';
import { apiBaseUrl } from 'yxt-biz-pc/packages/api';
// 拼接URL参数
const linkSubString = (url, data) => {
  if (url === null || url === '') {
    return url;
  }
  let queryString = '';
  if (typeof data === 'object') {
    for (var i in data) {
      queryString += i + '=' + data[i] + '&';
    }
  }
  if (url.indexOf('?') > url.indexOf('/')) {
    url += '&';
  } else {
    url += '?';
  }
  if (queryString !== '') {
    queryString = queryString.substr(0, queryString.length - 1);
  }
  url += queryString;
  return url;
};
// 获取任务列表
export const getInspectionList = (params, data) => {
  return apiBaseUrl.post(linkSubString('/si/statement/inspectionplan-list', params), data);
};
